export const Node = {
    preview: 'preview',
    lesson: 'lesson',
    homework: 'homework',
    report: 'report',
    summary: 'summary',
    library: 'library',
    gift: 'gift',
    read: 'read',
    look: 'look',
    node_star: 'node',
}

export const COURSE_TYPE = {
    video: 'video', // 介绍指令（PC 不用加）
    majorLesson: 'major', // 主课
    ctLesson: 'ctLesson', // PL 课，个性化辅导课
    readingLesson: 'readingLesson', // 阅读课
    trialLesson: 'trialLesson', // 体验营
    expandLesson: 'expandLesson', // 体验营
    web: 'web', // 卡片
    KETLesson: 'KETLesson', // ket
}


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/static/json/constant.js